import { FC } from "react"
import { Cpu } from "lucide-react"
import { useFormikContext } from "formik"
import { Integration } from "../../../../../types"
import SectionCard from "../../../section-card"
import { WidgetsCheckboxes } from "../../fields"

interface Props {
  integration?: Integration
  title?: string
}

const ModuleConfigurationSection: FC<Props> = ({ integration, title }) => {
  const { values } = useFormikContext<Integration>()
  if (values.type === "chatbot") return null
  return (
    <SectionCard
      icon={<Cpu size={15} />}
      title={title ?? "Module Configuration"}
    >
      <WidgetsCheckboxes integration={integration} />
    </SectionCard>
  )
}

export default ModuleConfigurationSection
